export default {"src":"https://s.sylndr.com/c-76a6baf/_next/static/media/arIcon.5333ae83.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};